import { render, staticRenderFns } from "./SaleVatRegimeSelect.vue?vue&type=template&id=660004d7&scoped=true"
import script from "./SaleVatRegimeSelect.vue?vue&type=script&lang=ts"
export * from "./SaleVatRegimeSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660004d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('660004d7')) {
      api.createRecord('660004d7', component.options)
    } else {
      api.reload('660004d7', component.options)
    }
    module.hot.accept("./SaleVatRegimeSelect.vue?vue&type=template&id=660004d7&scoped=true", function () {
      api.rerender('660004d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/SaleVatRegimeSelect.vue"
export default component.exports